// extracted by mini-css-extract-plugin
export default {"footer":"footer-xf6r","space":"space-j38u"};